import React, { useState } from 'react'
import { useQuery, useMutation } from 'react-apollo-hooks'
import { Text } from 'rebass'
import get from 'lodash.get'

import {
  TextInput,
  Toggle,
  FormSection,
  Form,
} from '../Form'
import Card from '../Card'
import Section from '../Section'
import Loading from '../Loading'
import NotFound from '../NotFound'

import { updateRewardSchema } from '../../utilities/validations'
import queries from '../../queries'
import mutations from '../../mutations'

const Edit = ({ id, admin }) => {
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const { data, error: queryError, loading } = useQuery(queries.rewards.EDIT, {
    variables: { id },
    suspend: false,
    fetchPolicy: 'network-only',
  })
  const [updateReward] = useMutation(mutations.rewards.UPDATE)

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    setSuccess(null)
    setError(null)

    const variables = {
      ...updateRewardSchema.cast(values),
      id,
      status: values.status ? 'ACTIVE' : 'INACTIVE',
    }

    try {
      await updateReward({ variables })
      setSuccess('Reward was successfully updated')
    } catch (e) {
      setError(e.message)
    }

    setSubmitting(false)
  }

  if (queryError && queryError.message) return <Text color="error">{queryError.message}</Text>
  if (!loading && !data.reward) return <NotFound noMargin />

  return (
    <>
      <Section
        heading={`${admin ? 'Update' : 'Display'} Reward`}
        text="Give your customers a reason to keep coming back."
      >
        <Card>
          {loading
            ? <Loading />
            : (
              <Form
                initialValues={{
                  name: get(data, 'reward[0].name', ''),
                  description: get(data, 'reward[0].description', ''),
                  points: get(data, 'reward[0].points', ''),
                  status: get(data, 'reward[0].status', '') === 'ACTIVE',
                }}
                validationSchema={updateRewardSchema}
                onSubmit={onSubmit}
                submitLabel="Update Reward"
                error={error}
                success={success}
                canSubmit={admin}
              >
                <FormSection>
                  <Toggle name="status" label={['Active', 'Inactive']} disabled={!admin} />
                </FormSection>

                <FormSection
                  heading="Type"
                  text={(
                    <div>
                      {get(data, 'reward[0].type', '') === 'IN_PERSON' ? 'In person, redemptions will be completed immediately within the app.' : ''}
                      {get(data, 'reward[0].type', '') === 'CLAIMABLE' ? 'Claimable, redemptions must be marked as completed in the portal.' : ''}
                      {get(data, 'reward[0].type', '') === 'ONLINE' ? 'Online, redemptions must be marked as completed in the portal along'
                      + ' with further instructions for the user.' : ''}
                    </div>
                  )}
                />

                <FormSection
                  heading="Public"
                  text="This information will appear in the mobile application."
                >
                  <TextInput name="name" placeholder="Catchy and descriptive name" label="Reward Name" disabled={!admin} />
                  <TextInput name="description" placeholder="Describe this reward in detail" label="Reward Description" area disabled={!admin} />
                </FormSection>

                <FormSection
                  heading="Points"
                  text="Points are the currency used to redeem this reward. When
                determining the cost of this reward keep in mind how many points your customers receive by crossing
                into your zones."
                >
                  <TextInput name="points" placeholder="Points required to redeem this reward" type="number" label="Point Value" disabled={!admin} />
                </FormSection>
              </Form>
            )
        }
        </Card>
      </Section>
    </>
  )
}

export default Edit
